module.exports = __webpack_public_path__ + "img/divide-03.e92aec42.svg";